<template>
  <v-tooltip v-if="debtAmount > 0" bottom>
    <template #activator="{ on, attrs }">
      <AppChip
        color="#cc5500"
        v-bind="attrs"
        text-color="white--text"
        data-test="debtBadge"
        v-on="on"
        >{{
          $t("organisations:organisationProfile.debts.badge", "Debts")
        }}</AppChip
      >
    </template>
    <span>{{
      $t(
        [
          "organisations:organisationProfile.debts.tooltip",
          "Details: {\{debtToFederationAmount}\} to Federation; {\{debtToTopRegionOrganisationAmount}\} to League"
        ],
        {
          debtToFederationAmount: masterCurrency(
            organisation.debtToFederationCents
          ),
          debtToTopRegionOrganisationAmount: masterCurrency(
            organisation.debtToTopRegionOrganisationCents
          ),
          interpolation: { escapeValue: false }
        }
      )
    }}</span>
  </v-tooltip>
</template>
<script>
import { defineComponent, computed } from "vue";
import gql from "fraql";
import AppChip from "@elements/AppChip.vue";
import { useCurrency } from "@/composables/masterdata/config";

export default defineComponent({
  name: "AppShowOrganisationDebtBadge",
  components: { AppChip },
  props: {
    organisation: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { masterCurrency } = useCurrency();
    const debtAmount = computed(() => {
      return (
        (props.organisation.debtToFederationCents ?? 0) +
        (props.organisation.debtToTopRegionOrganisationCents ?? 0)
      );
    });

    return { debtAmount, masterCurrency };
  },
  fragments: {
    organisationFields: gql`
      fragment _ on Organisation {
        debtToFederationCents
        debtToTopRegionOrganisationCents
      }
    `
  }
});
</script>
